import { Collapse } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { getIsMobile } from '../../redux/window';
import styles from './collapsible_panel.less';

export interface CollapsiblePanelProps {
  title: string;
  defaultOpenMobile?: boolean;
  defaultOpenDesktop?: boolean;
  children: React.ReactNode;
}

export const CollapsiblePanel = (props: CollapsiblePanelProps) => {
  const { defaultOpenMobile, title, defaultOpenDesktop } = props;
  const isMobile = useSelector(getIsMobile);

  const defaultOpen = (isMobile && defaultOpenMobile) || (!isMobile && defaultOpenDesktop);
  return (
    <Collapse
      defaultActiveKey={defaultOpen ? [title] : null}
      expandIconPosition="end"
      className={styles.collapsible_panel}
    >
      <Collapse.Panel header={title} key={title}>
        {props.children}
      </Collapse.Panel>
    </Collapse>
  );
};
